import React from "react";

import { AW23 } from "../../../../js/database/database-aw23-eshop.js";

import ProductsContainer from "../../../../components/containers/ProductsContainer.js";
import { SwiperSlide } from "swiper/react";

const MemoryLeatherJacket = () => {
  return (
    <ProductsContainer
      pageTitle={AW23.jackets.MemoryLeatherJacket.itemName}
      name={AW23.jackets.MemoryLeatherJacket.itemName}
      price={AW23.jackets.MemoryLeatherJacket.itemPrice}
      fabric={AW23.jackets.MemoryLeatherJacket.itemFabric}
      src={AW23.jackets.MemoryLeatherJacket.sizeChart}
      divId={AW23.jackets.MemoryLeatherJacket.shopifyDivId}
      mainId={AW23.jackets.MemoryLeatherJacket.shopifyId}
      buttonShouldHide={true}
    >
      {React.Children.toArray(
        AW23.jackets.MemoryLeatherJacket.pictures.map(({ srcJpeg }) => (
          <SwiperSlide>
            <img
              src={srcJpeg}
              alt={AW23.jackets.MemoryLeatherJacket.itemName}
              width={AW23.imgWidth}
              height={AW23.imgHeight}
              loading={AW23.loading}
            />
          </SwiperSlide>
        ))
      )}
    </ProductsContainer>
  );
};

export default MemoryLeatherJacket;
